import React, {Component} from "react";
import {reduxForm} from "redux-form/immutable";
import ActionButton from "../../components/ActionButton";
import FormError from "../../components/forms/FormError";
import "./ViewMessageDataForm.css";

class ViewMessageDataForm extends Component {

  render() {
    let {errors, handleSubmit, data, submitting} = this.props;
    return (
      <form className="ViewMessageDataForm" onSubmit={handleSubmit}>
        <div className="fields">
          <textarea value={data} />
        </div>
        <FormError error={errors._error} />
        <div className="buttons">
          <ActionButton label="Cancel" active={!submitting} onClick={this.props.onCancel} />
          <ActionButton label="Delete" active={!submitting} onClick={this.props.onDelete} />
        </div>
      </form>
    )
  }
}

const ReduxForm = reduxForm({
  form: "ViewMessageDataForm"
})(ViewMessageDataForm);

export default ReduxForm;